import assign from 'lodash/assign';
import forEach from 'lodash/forEach';
import imageUtils from 'app/shared/utils/imageUtils';
import includes from 'lodash/includes';

type GalleryPhoto = {
  url: string;
  caption: string;
  modelId?: string;
  noPhoto?: boolean;
  isStreetView?: boolean;
};

type GalleryFloorplan = {
  largePhotos?: Array<GalleryPhoto>;
  modelId?: string;
};

type GalleryListing = {
  largePhotos?: Array<GalleryPhoto>;
  photos?: Array<GalleryPhoto>;
  previewPhoto?: GalleryPhoto;
  floorplans?: Array<GalleryFloorplan>;
};

const controller = {
  getPhotos: (listing: GalleryListing | null | undefined, excludeLargePhotos = false, _googleMapsKey?: string) => {
    if (!listing) {
      return imageUtils.noImageFound();
    }

    let photos: Array<GalleryPhoto> = [];

    if (listing.largePhotos && listing.largePhotos.length && !excludeLargePhotos) {
      photos = photos.concat(listing.largePhotos);
    } else if (listing.photos && listing.photos.length) {
      photos = photos.concat(listing.photos);
    }

    // add floorplan photos to gallery, deduplicating by URL
    const floorplanPhotos = controller.getFloorplanPhotos(listing);
    const seenUrls = new Set(photos.map((p) => p.url));
    forEach(floorplanPhotos, (photo) => {
      if (!seenUrls.has(photo.url)) {
        seenUrls.add(photo.url);
        photos.push(photo);
      }
    });

    if (photos[0] && photos[0].url) {
      return photos;
    }

    // Fall back to previewPhoto (may be a placeholder) or noImageFound
    if (listing.previewPhoto && listing.previewPhoto.url && !listing.previewPhoto.noPhoto) {
      const previewPhoto = listing.previewPhoto;
      if (includes(previewPhoto.url, 'thumb')) {
        previewPhoto.url = previewPhoto.url.replace(/thumb/, 'large');
      } else if (includes(previewPhoto.url, 'medium')) {
        previewPhoto.url = previewPhoto.url.replace(/medium/, 'large').replaceAll('500', '1200');
      }

      return [previewPhoto];
    }

    return imageUtils.noImageFound();
  },
  getFloorplanPhotos: (listing: GalleryListing) => {
    const { floorplans } = listing;
    const floorplanPhotos: Array<GalleryPhoto> = [];

    forEach(floorplans, (fp: GalleryFloorplan = {}) => {
      const { largePhotos: fpPhotos = [] } = fp;
      forEach(fpPhotos, (photo) => {
        /**
         *  must add modelId for floorplan fdp because index is unreliable
         * (photo gallery shows floorplans with photos and not all floorplans have photos)
         */
        const photoObjWithId = assign(photo, { modelId: fp.modelId });
        floorplanPhotos.push(photoObjWithId);
      });
    });

    if (floorplanPhotos[0] && floorplanPhotos[0].url) {
      return floorplanPhotos;
    } else {
      return [];
    }
  },
};

export default controller;
